
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ButtonToolbar } from 'react-bootstrap';


import "../style/App.css";
import "../style/ReactBootstrapOverride.css";
import "../style/Home.css";
import { SocialIcon } from 'react-social-icons'


const Footer = () => {

    return (

        <div className="mt-auto" 
        style={ 
            { backgroundColor: "#e30a13",  
              borderColor: "#e30a13" }}>
        <Container className="p-3">
            <Row className="col-white">
                <Col>
                    <h4>
                        CFI SURGERY
                    </h4>

                </Col>
                <Col>
                    <h4>
                        QUICK LINKS
                    </h4>
                </Col>
                <Col>
                    <h4>
                        RESEARCH
                    </h4>
                </Col>
            </Row>
            <Row className="col-white">
                <Col>
                    <Row>
                        <p className="col-white">
                            Bringing medical training into the 21st century. 
                        </p>
                    </Row>
                    <Row>
                        <ButtonToolbar aria-label="Toolbar with button groups" className='my-2'>
                            <SocialIcon className='mx-2' url="www.linkedin.com" bgColor='white' fgColor='black' href='https://www.linkedin.com/company/cfi-surgery'/>
                            <SocialIcon className='mx-2' url="www.instagram.com" bgColor='white' fgColor='black' href='https://www.instagram.com/cfisurgery/'/>
                            <SocialIcon className='mx-2' url="www.vimeo.com" bgColor='white' fgColor='black' href='https://vimeo.com/user37398434'/>
                        </ButtonToolbar>
                    </Row>
                    <Row>
                        <p>
                            © 2023 CFI SURGERY PTY LTD 
                        </p>
                    </Row>

                </Col>
                <Col>
                    <Row>
                        <a className="col-white" href="/">HOME</a>
                    </Row>
                    <Row>
                        <a className="col-white" href="/about">ABOUT US</a>
                    </Row>
                    <Row>
                        <a className="col-white" href="/STCH">PROCESS</a>
                    </Row>
                    <Row>
                        <a className="col-white" href="/login">CLIENT LOGIN</a>
                    </Row>
                </Col>
                <Col>
                    <ul>
                        <li>
                        <a className="col-white" href="https://www.heartlungcirc.org/article/S1443-9506(17)30272-X/fulltext">Learning Coronary Anastomosis</a>    
                        </li>
                        <li>
                        <a className="col-white" href="https://www.heartlungcirc.org/article/S1443-9506(23)00275-5/fulltext">The Reinforcement of Quantitative Assessment on Individual Surgical Training</a>    
                        </li>
                    </ul>
                    {/* <Row>
                        <a className="col-white" href="https://www.heartlungcirc.org/article/S1443-9506(17)30272-X/fulltext">Learning Coronary Anastomosis</a>
                    </Row>
                    <Row>
                        <a className="col-white" href="https://www.heartlungcirc.org/article/S1443-9506(23)00275-5/fulltext">The Reinforcement of Quantitative Assessment on Individual Surgical Training</a>
                    </Row> */}
                </Col>
            </Row>
        </Container>
        </div>
    );
}

export default Footer;